var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.391 20.105c.336 0 .609.273.609.609v.677a.609.609 0 01-.609.609H9.61A.609.609 0 019 21.391v-.677c0-.336.273-.609.609-.609H22.39zm0-5.052c.336 0 .609.272.609.608v.678a.609.609 0 01-.609.608H9.61A.609.609 0 019 16.34v-.678c0-.336.273-.608.609-.608H22.39zm0-5.053c.336 0 .609.273.609.609v.677a.609.609 0 01-.609.609H9.61A.609.609 0 019 11.286v-.677c0-.336.273-.609.609-.609H22.39z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgMenu;